jQuery(function($) {
    $(document).ready(function() {
        // To add Class on Header
        $(".custom-hamburger").click(function() { //use a class, since your ID gets mangled
            $('header').toggleClass("toggle-navbar"); //add the class to the clicked element
        });
        $(".scroll-down").click(function() {
            $('html, body').animate({
                scrollTop: $(this).offset().top
            }, 600);
        });
    });
});